import { fetch } from '@/utils/http'
import { fetchStream } from '@/utils/sse'

export default {
  getModel: params => fetch('get', '/cbaas-ai/v1/model', params),
  ask: (params, onStart, onUpdate, onError, onClose) => fetchStream('post', '/cbaas-ai/v1/conversations', params, onStart, onUpdate, onError, onClose),
  clearMessages: params => fetch('delete', `/cbaas-ai/v1/conversations?uid=${params.uid}`, params),
  getMessageList: params => fetch('post', '/cbaas-ai/v1/conversations/list', params)
}
